export type ContainerId = number;

/** Drawer ids grouped by row, top to bottom -- the top row of 4, then drawer 4 alone spanning the row below it */
export const drawerIds: number[][] = [[0, 1, 2, 3], [4]];

/** Every drawer id, flattened out of drawerIds' row grouping, in display order */
export const allDrawerIds: ContainerId[] = drawerIds.flat();

/** Maps drawer IDs to their relay numbers */
export const drawerToRelayMap: Record<number, number> = {
  0: 7,
  1: 8,
  2: 1,
  3: 2,
  4: 6,
};

export function getRelayNumber(drawerId: ContainerId): number {
  const relayNum = drawerToRelayMap[drawerId];
  if (relayNum === undefined) {
    throw new Error(`No relay mapping found for drawer ${drawerId}`);
  }
  return relayNum;
}
